import { map } from "./state/map.slice";
import { sidebar } from "./state/sidebar.slice";
import { dispatch } from "./state/root.store";

export const setMapView = (savedMapViewId: string) => {
    dispatch(map.actions.setMapView(savedMapViewId));
    closePopover();
};

export const closePopover = () => {
    dispatch(sidebar.actions.closePopover());
    dispatch(sidebar.actions.setFullScreenSelector(null));
};
